/**
 * Util file for common ReviewSummary mappings
 */

import { RACQAddressResult } from '@/interfaces';
import { formatAddress } from './address-format';

export function mapVehicle(
  make: string | undefined,
  model: string | undefined,
  year: string | undefined,
  colour: string | undefined,
  variant?: string | undefined
): string {
  if (!make && !model) {
    return '';
  }

  // Construct the result based on available values
  const result = [make, model, year, variant, colour].filter(Boolean).join(' ');

  return result || '';
}

export const formatAbn = (abn: string | undefined) => {
  if (!abn || abn.length !== 11) {
    // Do nothing if ABN is incorrect length
    return abn;
  }

  // Regex to format XX XXX XXX XXX
  return abn.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
};

export const formatAcn = (acn: string | null | undefined) => {
  if (!acn || acn.length !== 9) {
    // Do nothing if ACN is incorrect length
    return acn;
  }

  // Regex to format XXX XXX XXX
  return acn.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
};

export const mapMemberName = (
  title: string | undefined,
  firstName: string | undefined,
  lastName: string | undefined
): string => {
  const result = [title, firstName, lastName].filter(Boolean).join(' ');
  return result.trim() || '';
};

/**
 * Formats an address for display in review summaries
 * @deprecated Use formatAddress from address-format.ts directly for new code
 */
export const mapAddress = (address?: RACQAddressResult): string => {
  return formatAddress(address);
};
